import { faFloppyDisk, faHistory, faPen, faRefresh, faUndo } from "@fortawesome/pro-regular-svg-icons";
import i18n from "i18next";
import { HorizontalBox } from "src/components/common/box/HorizontalBox.tsx";
import { AsyncButton } from "src/components/common/buttons/AsyncButton.tsx";

interface CustomerOrderProfitabilityActionsProps {
	isEditMode: boolean;
	onRefresh: () => Promise<void>;
	onOpenHistory: () => Promise<void>;
	onEdit: () => Promise<void>;
	onUndo: () => Promise<void>;
	onSave: () => Promise<void>;
}

export const CustomerOrderProfitabilityActions = ({
	isEditMode,
	onRefresh,
	onOpenHistory,
	onEdit,
	onUndo,
	onSave,
}: CustomerOrderProfitabilityActionsProps) => {
	return (
		<HorizontalBox
			sx={{
				justifyContent: "space-between",
				alignItems: "center",
				gap: 1,
				flexWrap: "wrap",
				paddingX: 2,
				paddingY: 1,
				borderBottom: "1px solid",
				borderColor: "divider",
			}}
		>
			<AsyncButton
				icon={faRefresh}
				label={i18n.t("refresh")}
				variant="text"
				onClick={onRefresh}
				disabled={isEditMode}
			/>
			<HorizontalBox sx={{ gap: 1, flexWrap: "wrap", justifyContent: "flex-end" }}>
				<AsyncButton
					icon={faHistory}
					label={i18n.t("history")}
					variant="text"
					onClick={onOpenHistory}
				/>
				{!isEditMode && (
					<AsyncButton
						icon={faPen}
						label={i18n.t("edit")}
						variant="text"
						onClick={onEdit}
					/>
				)}
				{isEditMode && (
					<>
						<AsyncButton
							icon={faUndo}
							label={i18n.t("undo")}
							variant="text"
							onClick={onUndo}
						/>
						<AsyncButton
							icon={faFloppyDisk}
							label={i18n.t("save")}
							variant="text"
							onClick={onSave}
						/>
					</>
				)}
			</HorizontalBox>
		</HorizontalBox>
	);
};
